
export default {
  formActions: {
    addPlaceInput: 'Punkt hinzufügen',
    clearRoute: 'Route zurücksetzen',
    reverseRoute: 'Route invertieren',
    roundTrip: 'Rundweg',
    toggleRoundTrip: 'Rundweg an/aus',
    showDangerousAreas: 'Farlige områder'
  }
}
